// @flow

import React from "react";
import { Switch as ChakraSwitch } from "@chakra-ui/react";

type Props = {
  isChecked: boolean,
  onChange: Function,
  isDisabled?: boolean,
  color?: string,
  size?: string,
};

const Switch = ({
  isChecked = false,
  onChange,
  color = "whatsapp",
  size = "md",
  isDisabled = false,
}: Props) => {
  return (
    <ChakraSwitch
      isChecked={isChecked}
      colorScheme={color}
      size={size}
      onChange={onChange}
      isDisabled={isDisabled}
    />
  );
};

export default Switch;
